<template>
	<div class="useragree" v-html="content">      
		
	</div>
</template>

<script>
import netFetch from '@/config/api'
export default {
	name: 'UserAgree',
	created() {
		this.init();
	},
	beforeRouteEnter(to, from, next) {
		if(from.name == 'aboutUs'){
			next()
		}else{
			var json = JSON.stringify({
				path:to.fullPath
			})
			window.localStorage.setItem('json',json);
			next()
		}
	},
	mounted(){
		var type = this.$route.query.type;
		if(type == 17){document.title = '用户注册协议';}
		if(type == 18){document.title = '用户隐私政策';}
		if(type == 16){document.title = '儿童隐私政策';}
		
		this.$bridge.registerhandler('returnAbout', () => {
			this.returnAbout();
		})
	},
	data () {
		return {
			content: '',
			webHeight: ''
		}
	},
	destroyed(){
		window.localStorage.removeItem('json');
	},
	methods: {
		init (){
			netFetch('getwebcontent','POST',{
				contentid: this.$route.query.type?this.$route.query.type:8
			}).then((res)=>{
				var content = res.rows[0].content;
				this.content = content
			})
		},
		webloaded (obj){
			let ratio = 2;
			if (obj.width) {
				ratio = 750/obj.width
			}
			this.webHeight = parseInt(obj.height*ratio)+'px';
		},
		returnAbout(){
			this.$router.push({
				path:'/aboutUs'
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.useragree{
	width: 100%;
	background-color: #ffffff;
	padding-left: 10px;
	padding-right: 10px;
	box-sizing: border-box;
	padding-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/cUser/UserAgree.vue